import dayjs from "dayjs";
import "dayjs/locale/sv";

export const getNowDate = (): Date => {
  dayjs.locale("sv");
  return dayjs().toDate();
};
